/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_OrdersInputs */

const en_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Orders`)
};

const es_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver pedidos`)
};

const fr_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les commandes`)
};

const de_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen ansehen`)
};

const ja_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注文を見る`)
};

const zh_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看订单`)
};

const ar_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الطلبات`)
};

const id_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Pesanan`)
};

const it_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza Ordini`)
};

const ru_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть заказы`)
};

const pt_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Pedidos`)
};

const ko_view_orders = /** @type {(inputs: View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주문 보기`)
};

/**
* | output |
* | --- |
* | "View Orders" |
*
* @param {View_OrdersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const view_orders = /** @type {((inputs?: View_OrdersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_OrdersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_orders(inputs)
	if (locale === "es") return es_view_orders(inputs)
	if (locale === "fr") return fr_view_orders(inputs)
	if (locale === "de") return de_view_orders(inputs)
	if (locale === "ja") return ja_view_orders(inputs)
	if (locale === "zh") return zh_view_orders(inputs)
	if (locale === "ar") return ar_view_orders(inputs)
	if (locale === "id") return id_view_orders(inputs)
	if (locale === "it") return it_view_orders(inputs)
	if (locale === "ru") return ru_view_orders(inputs)
	if (locale === "pt") return pt_view_orders(inputs)
	return ko_view_orders(inputs)
});